<template>
  <div>
    <div class="row">
      <v-select
        v-model="remarkContents[0]"
        :disabled="true"
        :items="remarkContents"
        item-text="value"
        item-value="id"
      />
      <v-btn
        :disabled="!canUserEdit || typeDefinitionId === 0"
        class="mt-3"
        color="success"
        flat
        @click="OpenModal"
      >
        Bearbeiten
      </v-btn>
    </div>
    <b-modal
      :ref="'editHintText'"
      class="w-100"
      hide-footer
      size="xl"
      title="Hinweisetexte bearbeiten"
      @close="LoadRemarkContents"
    >
      <u-error-handling
        v-if="errorObject"
        :error-object="errorObject"
      />
      <div>
        <v-btn
          v-if="canUserEdit && typeDefinitionId !== 0"
          :disabled="remarkContents.length === languageOptions.length"
          color="success"
          flat
          @click="AddRemarkContent"
        >
          <i class="fas fa-plus mr-3" /> Erfassen
        </v-btn>
      </div>
      <div
        v-for="(remarkContent, index) in remarkContents"
        :key="index"
      >
        <div class="row mb-2">
          <v-select
            v-model="remarkContent.language"
            :items="languageOptions"
            item-text="text"
            item-value="language"
            label="Sprache"
            class="col-md-3"
          />
          <v-text-field
            v-model="remarkContent.value"
            label="Hinweistext"
            class="col-md-6"
          />
          <v-btn
            v-if="canUserEdit"
            class="col-md-1"
            color="error"
            flat
            @click="RemoveRemarkContent(index)"
          >
            <i class="fas fa-trash mr-3" />
          </v-btn>
        </div>
      </div>
      <div>
        <b-button
          variant="success"
          @click="SaveRemarkContents"
        >
          Speichern
        </b-button>
        <b-button
          class="ml-2"
          variant="danger"
          @click="CloseModal"
        >
          Abbrechen
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import {
  GetTypeDefinitionRemarkContents,
  UpdateTypeDefinitionRemarkContents,
} from "@/services/minimum.wage.services/zuschlagsrechner/definition";
import { GetLanguageNameFromCode } from "../../../../../helpers/LanguageHelper";

export default {
  mixins: [MinimumWageMixin],
  props: {
    zuschlagsConfigurationId: {
      type: Number,
      required: true,
    },
    typeDefinitionId: {
      type: Number,
      required: true,
    },
    languages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      errorObject: null,
      isLoading: true,
      remarkContents: [],
      criteriaOptions: [],
      selectedCriteria: null,
      criteriaEntryOptions: [],
      selectedCriteriaEntries: [],
    };
  },
  computed: {
    languageOptions() {
      let languages = [
        ...this.$store.state.mindestLohnKonfiguration.BasicContractInformation
          .translatedLanguages,
      ];
      let options = [];
      languages.forEach((lang) => {
        options.push({
          id: lang.id,
          language: lang.language,
          text: GetLanguageNameFromCode(lang.language),
        });
      });
      return options;
    },
  },
  created() {
    this.LoadRemarkContents();
  },
  methods: {
    OpenModal() {
      this.showModal(`editHintText`);
    },
    CloseModal() {
      this.hideModal(`editHintText`);
      this.LoadRemarkContents();
    },
    AddRemarkContent() {
      var newRemarkContents = [...this.remarkContents];
      this.languageOptions.forEach((language) => {
        if (
          !newRemarkContents.some(
            (content) => content.language === language.language,
          )
        ) {
          newRemarkContents.push({
            id: 0,
            value: "",
            language: language.language,
          });
        }
      });
      this.remarkContents = newRemarkContents;
    },
    RemoveRemarkContent(index) {
      this.remarkContents.splice(index, 1);
    },
    SaveRemarkContents() {
      this.isLoading = true;
      UpdateTypeDefinitionRemarkContents(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        this.zuschlagsConfigurationId,
        this.typeDefinitionId,
        this.remarkContents,
        () => {
          this.isLoading = false;
          this.CloseModal();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    LoadRemarkContents() {
      this.isLoading = true;
      GetTypeDefinitionRemarkContents(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        this.zuschlagsConfigurationId,
        this.typeDefinitionId,
        (response) => {
          this.remarkContents = response;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    showModal(modalId) {
      this.$refs[modalId].show();
    },
    hideModal(modalRef) {
      if (this.$refs[modalRef]) {
        this.$refs[modalRef].hide();
      }
    },
  },
};
</script>

<style></style>
